export const Options = {
    Salutation: [
        { text: "Herr", value: "m" },
        { text: "Frau", value: "w" },
        { text: "Divers", value: "d" },
    ],
    Nationality: [
        { text: "EU mit unbefristeter Arbeitserlaubnis", value: "EU" },
        { text: "EU mit befristeter Arbeitserlaubnis", value: "EUb" },
        { text: "EU ohne Arbeitserlaubnis", value: "EUo" },
        { text: "Nicht EU mit unbefristeter Arbeitserlaubnis", value: "Niu" },
        { text: "Nicht EU mit befristeter Arbeitserlaubnis", value: "Nib" },
        { text: "Nicht EU ohne Arbeitserlaubnis", value: "Nio" },
    ],
    SchoolEducation: [
        { text: "Kein Abschluss", value: "Kein Abschluss" },
        { text: "Hauptschulabschluss", value: "Hauptschulabschluss" },
        { text: "Realschulabschluss/Fachoberschulreife/Mittlere Reife", value: "Realschulabschluss/Fachoberschulreife/Mittlere Reife" },
        { text: "Fachhochschulreife", value: "Fachhochschulreife" },
        { text: "Allgemeine Hochschulreife/Abitur", value: "Allgemeine Hochschulreife/Abitur" },
    ],
    BecomingAwareThrough: [
        { text: "Monster.de", value: "Monster.de" },
        { text: "Stellenwerk.de", value: "Stellenwerk.de" },
        { text: "Stepstone.de", value: "Stepstone.de" },
        { text: "Zeitungsannonce", value: "Zeitungsannonce" },
        { text: "Aubi-plus", value: "Aubi-plus" },
        { text: "Azubiyo", value: "Azubiyo" },
        { text: "Jobbörse der Bundesagentur für Arbeit", value: "Jobbörse der Bundesagentur für Arbeit" },
        { text: "Social Media (Facebook, Instagram, Xing etc.)", value: "Social Media (Facebook, Instagram, Xing etc.)" },
        { text: "Flyer/Werbeplakate", value: "Flyer/Werbeplakate" },
        { text: "Familie/Freunde/Bekannte", value: "Familie/Freunde/Bekannte" },
        { text: "Messe/Informationsveranstaltung/Jobbörse", value: "Messe/Informationsveranstaltung/Jobbörse" },
        { text: "Suchmaschine (Google, Safari, Bing etc.)", value: "Suchmaschine (Google, Safari, Bing etc.)" },
        { text: "Kooperationspartner", value: "Kooperationspartner" },
        { text: "Schule/Universität", value: "Schule/Universität" },
        { text: "Headhunter/Personalvermittler", value: "Headhunter/Personalvermittler" },
        { text: "Mitarbeiter werben Mitarbeiter", value: "Mitarbeiter werben Mitarbeiter" },
        { text: "Sonstige", value: "Sonstige" },
    ]
}
